import { NgOptimizedImage } from '@angular/common';
import { Component } from '@angular/core';

import { environment } from '@env/environment';
import { Button, VideoPlayerComponent } from '@shared/components';

@Component({
  selector: 'app-hero',
  imports: [Button, NgOptimizedImage, VideoPlayerComponent],
  templateUrl: './hero.html',
  styleUrl: './hero.scss',
})
export class Hero {
  readonly environment = environment;
}
